import * as THREE from 'three/webgpu';
import {
	SketchEllipseControlPointFactory,
	SketchEllipseObject,
} from '../../../../mesh/sketch';
import type { SketchEllipseDefinition } from '../../../../mesh/sketch';
import type {
	EllipseReferenceBuilderInput,
	EllipseReferenceAxisMarkers,
} from '../../../../../types/reference/sketch-entity-reference/EllipseReferenceBuilder';

export type {
	EllipseReferenceBuilderInput,
	EllipseReferenceAxisMarkers,
} from '../../../../../types/reference/sketch-entity-reference/EllipseReferenceBuilder';

/**
 * 椭圆引用构建器。
 * 说明：
 * 1. 当前阶段只负责创建完整椭圆本体及 cardinal 控制点；
 * 2. 额外把轴端标记保存到对象自定义属性，为 Task 5 的关系恢复预留读取入口；
 * 3. 不在此处恢复任何约束，仅维持对象定义与控制点同步协议。
 */
export class EllipseReferenceBuilder {
	/**
	 * 构建草图椭圆对象。
	 *
	 * @param input 构建输入。
	 * @returns 已完成几何初始化的椭圆对象。
	 */
	public build(input: EllipseReferenceBuilderInput): SketchEllipseObject {
		const definition: SketchEllipseDefinition = {
			centerWorld: new THREE.Vector3(...input.geometryPayload.centerWorld),
			radiusX: input.geometryPayload.radiusX,
			radiusY: input.geometryPayload.radiusY,
			rotation: input.geometryPayload.rotation,
			startAngle: 0,
			endAngle: Math.PI * 2,
			clockwise: false,
		};
		const controlPointFactory = new SketchEllipseControlPointFactory(input.targetSketch.referencePlane);
		const centerPoint = controlPointFactory.createControlPoint(definition.centerWorld);
		const axisMarkers: EllipseReferenceAxisMarkers = controlPointFactory.createAxisControlPoints(definition);
		const ellipse = new SketchEllipseObject({
			referencePlane: input.targetSketch.referencePlane,
			definition,
			startPoint: axisMarkers.majorPositive,
			endPoint: axisMarkers.minorPositive,
			centerPoint,
		});

		ellipse.updateEllipse();
		controlPointFactory.registerCardinalControlPoints(ellipse, {
			centerPoint,
			axisControlPoints: axisMarkers,
		});

		Reflect.set(ellipse, '__referenceAxisMarkers', axisMarkers);

		return ellipse;
	}
}
